import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", [_c("h1", [_vm._v("Orders")]), !_vm.$whitelabel.MyOrdersListCustomerFiltersHidden ? _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-top-buttons"
  }, [_vm.canImportOrder ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.importOrder();
      }
    }
  }, [_c(VIcon, {
    staticClass: "icon-import-order",
    attrs: {
      dark: ""
    }
  }, [_vm._v("fas fa-file-upload")]), _vm._v(" Import order ")], 1) : _vm._e()], 1), _c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      placeholder: "Search for an order reference (...001)",
      clearable: "",
      "hide-details": "auto",
      loading: _vm.dataLoading,
      "append-icon": "fa-search"
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.label != _vm.searchLabelLastUsed && _vm.search(true);
      },
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.formSearch.label = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.label,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "label", $$v);
      },
      expression: "formSearch.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", {
    staticClass: "search-with-range-date"
  }, [_c(VAutocomplete, {
    attrs: {
      items: _vm.sortBy,
      "item-value": "id",
      "item-text": "label",
      label: "Sort by",
      solo: "",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.changeSortBy();
      }
    },
    model: {
      value: _vm.formSearch.sort_by,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "sort_by", $$v);
      },
      expression: "formSearch.sort_by"
    }
  }), _vm.formSearch.sort_by === "RANGE_DATE" ? _c("div", [_c(VMenu, {
    ref: "sortByRangeDatesMenu",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.formSearch.range_date,
      transition: "scale-transition",
      "offset-y": "",
      "read-only": "",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function updateReturnValue($event) {
        return _vm.$set(_vm.formSearch, "range_date", $event);
      },
      "update:return-value": function updateReturnValue($event) {
        return _vm.$set(_vm.formSearch, "range_date", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VCombobox, _vm._g(_vm._b({
          staticClass: "mt-small-2",
          attrs: {
            clearable: "",
            multiple: "",
            chips: "",
            "small-chips": "",
            solo: "",
            label: "Select two dates in range",
            "prepend-icon": "mdi-calendar",
            "hide-details": "auto"
          },
          on: {
            "click:clear": function clickClear($event) {
              return _vm.clearDateRange();
            }
          },
          model: {
            value: _vm.rangeDatesDisplay,
            callback: function callback($$v) {
              _vm.rangeDatesDisplay = $$v;
            },
            expression: "rangeDatesDisplay"
          }
        }, "v-combobox", attrs, false), on))];
      }
    }], null, false, 325252599),
    model: {
      value: _vm.sortByRangeDatesMenu,
      callback: function callback($$v) {
        _vm.sortByRangeDatesMenu = $$v;
      },
      expression: "sortByRangeDatesMenu"
    }
  }, [_c(VDatePicker, {
    attrs: {
      multiple: "",
      "no-title": "",
      scrollable: "",
      range: ""
    },
    on: {
      change: function change($event) {
        return _vm.formatDates();
      }
    },
    model: {
      value: _vm.formSearch.range_date,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "range_date", $$v);
      },
      expression: "formSearch.range_date"
    }
  }, [_c(VSpacer), _c(VBtn, {
    attrs: {
      text: "",
      color: "primary"
    },
    on: {
      click: function click($event) {
        _vm.sortByRangeDatesMenu = false;
      }
    }
  }, [_vm._v("Cancel")]), _c(VBtn, {
    attrs: {
      text: "",
      color: "primary"
    },
    on: {
      click: function click($event) {
        _vm.$refs.sortByRangeDatesMenu.save(_vm.formSearch.range_date), _vm.sortByDatesRanges();
      }
    }
  }, [_vm._v(" OK ")])], 1)], 1)], 1) : _vm._e()], 1), _c("div", {
    staticClass: "tags"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringToValidate ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("to_validate");
      }
    }
  }, [_vm._v(" In validation ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringInPreparation ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("in_preparation");
      }
    }
  }, [_vm._v(" In preparation ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringInTransit ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("in_transit");
      }
    }
  }, [_vm._v(" In delivery ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringHeld ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("held");
      }
    }
  }, [_vm._v(" Held ")]), _vm.canAccessInbound ? _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringInbound ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("inbound");
      }
    }
  }, [_vm._v(" Inbound ")]) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringDelivered ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("delivered");
      }
    }
  }, [_vm._v(" Delivered ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringCancelled ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("cancelled");
      }
    }
  }, [_vm._v(" Cancelled ")]), _vm.isFilteringStatus ? _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    on: {
      click: _vm.clearFiltersStatus
    }
  }, [_vm._v(" Clear all "), _c(VIcon, {
    attrs: {
      small: ""
    }
  }, [_vm._v("mdi-close")])], 1) : _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    on: {
      click: _vm.fillFiltersStatus
    }
  }, [_vm._v(" Add all "), _c(VIcon, {
    attrs: {
      small: ""
    }
  }, [_vm._v("mdi-plus")])], 1)], 1)]), _c("div", {
    staticClass: "search-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.formSearch.paging.currentPage,
      limits: Number(_vm.formSearch.paging.limits),
      totalNumber: _vm.baseModel.numberOfOrders
    }
  })], 1)])]) : _vm._e(), _c("div", [_vm.baseModel.orders.length == 0 && !_vm.dataLoading ? _c("div", {
    staticClass: "list-empty"
  }, [_vm._v(" No orders available. ")]) : _vm._e(), _c(VDataTable, {
    staticClass: "order-table cursor--pointer",
    attrs: {
      headers: _vm.headers,
      items: _vm.baseModel.orders,
      "items-per-page": +_vm.formSearch.paging.limits,
      "hide-default-footer": "",
      "disable-sort": "",
      "item-key": "id_order"
    },
    on: {
      "click:row": _vm.rowClick,
      "contextmenu:row": _vm.rowClickContextMenu
    },
    scopedSlots: _vm._u([{
      key: "item.referenceOrder",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c("div", {
          staticClass: "order-reference-column td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", {
          staticClass: "order-collapsis",
          attrs: {
            title: "See more details"
          },
          on: {
            click: function click($event) {
              item.isOrderExpanded = !item.isOrderExpanded;
            }
          }
        }, [_c(VIcon, [_vm._v(_vm._s(!item.isOrderExpanded ? "mdi-chevron-down" : "mdi-chevron-up"))])], 1), _c("div", {
          staticClass: "order-ref"
        }, [_c("div", {
          staticClass: "flex"
        }, [_c("router-link", {
          staticClass: "router-link",
          attrs: {
            to: _vm.orderDetails(item)
          }
        }, [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "open-delay": 500,
            disabled: item.isOrderExpanded
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref3) {
              var on = _ref3.on,
                attrs = _ref3.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c("strong", [_vm._v(_vm._s(item.reference_order.shorterReference()))])])];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_c("div", [_vm._v(_vm._s(_vm._f("formatDate")(item.date_order)))])])], 1)], 1), _c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref4) {
              var on = _ref4.on,
                attrs = _ref4.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                attrs: {
                  small: ""
                },
                on: {
                  click: function click($event) {
                    return _vm.copyToClipboard(item.reference_order);
                  }
                }
              }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
            }
          }], null, true)
        }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
          staticStyle: {
            color: "green"
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])], 1), _vm.isHolding(_vm.loggedUserData) ? [_vm.isImporterInvoiceConsultable(item) ? [_vm._v(" " + _vm._s(item.importerInvoiceNumberLabel) + " "), _c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref5) {
              var on = _ref5.on,
                attrs = _ref5.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                attrs: {
                  small: ""
                },
                on: {
                  click: function click($event) {
                    return _vm.copyToClipboard(item.importerInvoiceNumberLabel);
                  }
                }
              }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
            }
          }], null, true)
        }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
          staticStyle: {
            color: "green"
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])] : _vm.isInvoiceConsultable(item) ? [_vm._v(" " + _vm._s(item.invoiceNumberLabel) + " "), _c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref6) {
              var on = _ref6.on,
                attrs = _ref6.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                attrs: {
                  small: ""
                },
                on: {
                  click: function click($event) {
                    return _vm.copyToClipboard(item.invoiceNumberLabel);
                  }
                }
              }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
            }
          }], null, true)
        }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
          staticStyle: {
            color: "green"
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])] : _vm.hasBeenValidated(item) && item.isPreventInvoice ? [_vm._v(" " + _vm._s(_vm.getOrderConfirmationReference(item)) + " ")] : _vm._e()] : [_vm.isInvoiceConsultable(item) ? _c("div", {
          staticClass: "invoice-label"
        }, [_vm._v(" " + _vm._s(item.invoiceNumberLabel) + " "), _c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref7) {
              var on = _ref7.on,
                attrs = _ref7.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                attrs: {
                  small: ""
                },
                on: {
                  click: function click($event) {
                    return _vm.copyToClipboard(item.invoiceNumberLabel);
                  }
                }
              }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
            }
          }], null, true)
        }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
          staticStyle: {
            color: "green"
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])], 1) : _vm._e(), item.isImporterInvoiced ? _c("div", {
          staticClass: "invoice-label"
        }, [_vm._v(" " + _vm._s(item.importerInvoiceNumberLabel) + " "), _c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref8) {
              var on = _ref8.on,
                attrs = _ref8.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                attrs: {
                  small: ""
                },
                on: {
                  click: function click($event) {
                    return _vm.copyToClipboard(item.importerInvoiceNumberLabel);
                  }
                }
              }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
            }
          }], null, true)
        }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
          staticStyle: {
            color: "green"
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])], 1) : _vm._e(), _vm.hasBeenValidated(item) && item.isPreventInvoice ? _c("div", [_vm._v(" " + _vm._s(_vm.getOrderConfirmationReference(item)) + " ")]) : _vm._e()], _c(VExpandTransition, [item.isOrderExpanded ? _c("div", {
          staticClass: "expanded-section"
        }, [_c("i", [_vm._v("(" + _vm._s(_vm._f("formatDate")(item.date_order)) + ")")])]) : _vm._e()])], 2)])];
      }
    }, {
      key: "item.customer",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "close-on-content-click": false,
            "open-delay": 500,
            disabled: item.isOrderExpanded
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref10) {
              var on = _ref10.on,
                attrs = _ref10.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c(VExpandTransition, [item.user.id_user != +_vm.loggedUserData.idUser ? _c("div", {
                domProps: {
                  innerHTML: _vm._s(String.parseForVHtml(_vm.getFullNameUserHtml(item.user)))
                }
              }) : _c("div", {
                domProps: {
                  innerHTML: _vm._s(String.parseForVHtml("Me: ".concat(_vm.getFullNameUserHtml(item.user))))
                }
              })]), _c(VExpandTransition, [item.isOrderExpanded && item.user.id_user != +_vm.loggedUserData.idUser ? _c("div", {
                domProps: {
                  innerHTML: _vm._s("<span class='text-smaller text-italic'>" + _vm.userGroupName(item.user) + "</span>")
                }
              }) : _vm._e()])], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [item.user.company_name ? _c("div", [_vm._v("Company: " + _vm._s(item.user.company_name))]) : _vm._e(), _c("div", {
          domProps: {
            innerHTML: _vm._s("<span class=' text-italic'>" + _vm.userGroupName(item.user) + "</span>")
          }
        })])], 1)];
      }
    }, {
      key: "item.status",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "close-on-content-click": false,
            "open-delay": 500,
            disabled: item.isOrderExpanded
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref12) {
              var on = _ref12.on,
                attrs = _ref12.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c("div", {
                staticClass: "badge --small",
                class: _vm.getOrderStatusClass(item)
              }, [_vm._v(" " + _vm._s(_vm.orderStatus.find(function (x) {
                return x.status == item.status;
              }).valueBuyer) + " ")]), _c(VExpandTransition, [item.isOrderExpanded ? _c("div", {
                staticClass: "expanded-section"
              }, [_c("i", [_vm._v("(" + _vm._s(_vm._f("formatDate")(item.lastStatusUpdateDate)) + ")")])]) : _vm._e()])], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_c("div", [_vm._v(_vm._s(_vm._f("formatDate")(item.lastStatusUpdateDate)))])])], 1)];
      }
    }, {
      key: "item.isFullyCalculatedAmounts",
      fn: function fn(_ref13) {
        var item = _ref13.item;
        return [!item.isFullyCalculatedAmounts ? _c("div", [_c(VMenu, {
          attrs: {
            "open-on-hover": "",
            top: "",
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref14) {
              var on = _ref14.on,
                attrs = _ref14.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                attrs: {
                  color: "orange darken-2"
                }
              }, "v-icon", attrs, false), on), [_vm._v("mdi-alert")])];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "pa-2 text-sm"
        }, [_vm._v(" This order is being updated, the amount may be inaccurate ")])], 1)], 1) : _vm._e()];
      }
    }, {
      key: "item.amount",
      fn: function fn(_ref15) {
        var item = _ref15.item;
        return [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "close-on-content-click": false,
            "open-delay": 500,
            disabled: item.isOrderExpanded
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref16) {
              var on = _ref16.on,
                attrs = _ref16.attrs;
              return [_c("div", _vm._g(_vm._b({
                staticClass: "amount-column"
              }, "div", attrs, false), on), [_c("div", [_vm._v(" " + _vm._s(_vm.formatPrice(item.total_amount_currency)) + " " + _vm._s(_vm.getSymbolCurrency(item.currency)) + " ")]), _c(VExpandTransition, [item.isOrderExpanded ? _c("div", {
                staticClass: "quantity"
              }, [_c("i", [_vm._v(_vm._s("(".concat(item.quantity, " bottle").concat(item.quantity > 1 ? "s" : "", ")")))])]) : _vm._e()])], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_c("div", {
          staticClass: "quantity"
        }, [_vm._v(" " + _vm._s("".concat(item.quantity, " bottle").concat(item.quantity > 1 ? "s" : "")) + " ")])])], 1)];
      }
    }, {
      key: "item.deliveryAddress",
      fn: function fn(_ref17) {
        var _item$delivery_addres3;
        var item = _ref17.item;
        return [!item.is_destination_inbound && !item.isStockTransfer && item.status !== "SUBCONTAINER_PUT_INBOUND" ? _c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "close-on-content-click": false,
            "open-delay": 500,
            disabled: item.isOrderExpanded
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref18) {
              var _item$delivery_addres, _item$delivery_addres2;
              var on = _ref18.on,
                attrs = _ref18.attrs;
              return [_c("div", _vm._g(_vm._b({
                staticClass: "delivery-address-column"
              }, "div", attrs, false), on), [_c("div", [_c(VExpandTransition, [item.isOrderExpanded ? _c("div", [_c("div", [_vm._v(_vm._s(item.delivery_address.street))]), item.delivery_address.address_line_2 ? _c("div", [_vm._v(" " + _vm._s(item.delivery_address.address_line_2) + " ")]) : _vm._e(), item.delivery_address.address_line_3 ? _c("div", [_vm._v(" " + _vm._s(item.delivery_address.address_line_3) + " ")]) : _vm._e(), item.delivery_address.address_complement ? _c("div", [_vm._v(" " + _vm._s(item.delivery_address.address_complement) + ", ")]) : _vm._e(), _c("div", [_vm._v(" " + _vm._s((item.delivery_address.zip ? item.delivery_address.zip + " " : "") + item.delivery_address.city) + " ")]), _c("div", [_vm._v(" " + _vm._s(((_item$delivery_addres = item.delivery_address.state) !== null && _item$delivery_addres !== void 0 && _item$delivery_addres.state_label ? item.delivery_address.state.state_label + ", " : "") + item.delivery_address.country.printable_name) + " ")])]) : _vm._e()]), _c(VExpandTransition, [!item.isOrderExpanded ? _c("div", {
                staticClass: "delivery-address-default"
              }, [_vm._v(" " + _vm._s(item.delivery_address.country.printable_name + ", " + item.delivery_address.city + ((_item$delivery_addres2 = item.delivery_address.state) !== null && _item$delivery_addres2 !== void 0 && _item$delivery_addres2.state_label ? ", " + item.delivery_address.state.state_label : "")) + " ")]) : _vm._e()])], 1)])];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_c("div", {
          staticClass: "text-left"
        }, [_c("div", [_vm._v(_vm._s(item.delivery_address.street))]), item.delivery_address.address_line_2 ? _c("div", [_vm._v(" " + _vm._s(item.delivery_address.address_line_2) + " ")]) : _vm._e(), item.delivery_address.address_line_3 ? _c("div", [_vm._v(" " + _vm._s(item.delivery_address.address_line_3) + " ")]) : _vm._e(), item.delivery_address.address_complement ? _c("div", [_vm._v(" " + _vm._s(item.delivery_address.address_complement) + ", ")]) : _vm._e(), _c("div", [_vm._v(_vm._s(item.delivery_address.country.printable_name))]), _c("div", [_vm._v(" " + _vm._s(item.delivery_address.city + ((_item$delivery_addres3 = item.delivery_address.state) !== null && _item$delivery_addres3 !== void 0 && _item$delivery_addres3.state_label ? ", " + item.delivery_address.state.state_label : "") + (item.delivery_address.zip ? ", " + item.delivery_address.zip : "")) + " ")])])])], 1) : _c("div", {
          staticClass: "text-left"
        }, [_c("div", [_vm._v("Inbound warehouse")])])];
      }
    }, {
      key: "item.shipmentMethod",
      fn: function fn(_ref19) {
        var item = _ref19.item;
        return [item.expedition_method && item.shipmentLabel ? _c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "open-delay": 500,
            disabled: item.isOrderExpanded || !_vm.isEtaAvailable(item)
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref20) {
              var on = _ref20.on,
                attrs = _ref20.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c("div", [_c("i", {
                class: "fas ".concat(_vm.getShipmentMethodIcon(item), " mr-2")
              }), _vm._v(" " + _vm._s(item.shipmentLabel) + " ")]), _c(VExpandTransition, [item.isOrderExpanded && _vm.isEtaAvailable(item) ? _c("div", {
                staticClass: "expanded-section"
              }, [_vm._v(" ETA : " + _vm._s(_vm.getEtaLabel(item.etaMinHours, item.etaMaxHours)) + " ")]) : _vm._e()])], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_c("div", {
          staticClass: "expanded-section"
        }, [_vm._v(" ETA : " + _vm._s(_vm.getEtaLabel(item.etaMinHours, item.etaMaxHours)) + " ")])])], 1) : _c("div", {
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")])];
      }
    }, {
      key: "item.orderDate",
      fn: function fn(_ref21) {
        var item = _ref21.item;
        return [item.date_order ? _c("div", [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.date_order)) + " ")]) : _c("div", [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")])];
      }
    }, {
      key: "item.deliveryDate",
      fn: function fn(_ref22) {
        var item = _ref22.item;
        return [item.deliveryFinalDate ? _c("div", [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.deliveryFinalDate)) + " ")]) : _c("div", [_vm._v(_vm._s(_vm.emptyCellContent))])];
      }
    }])
  })], 1), !_vm.$whitelabel.MyOrdersCustomerSearchAndPaginationHidden && _vm.baseModel.numberOfPages >= 2 ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("paging", {
    attrs: {
      numberOfPages: _vm.baseModel.numberOfPages,
      currentPage: _vm.formSearch.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.formSearch.paging.currentPage,
      limits: Number(_vm.formSearch.paging.limits),
      totalNumber: _vm.baseModel.numberOfOrders
    }
  })], 1)])]) : _vm._e()]), _c("Confirm", {
    ref: "confirm"
  }), _c("ImportOrderDialogVue", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    model: {
      value: _vm.isImportOrderShown,
      callback: function callback($$v) {
        _vm.isImportOrderShown = $$v;
      },
      expression: "isImportOrderShown"
    }
  }), _c("ContextMenu", {
    ref: "contextMenu"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };